import React from 'react';
import SignupHeader from './SignupHeader';
import EmailSignupForm from './EmailSignupForm';

const SignupSection: React.FC = () => (
  <section id="signup" className="py-24 bg-white">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <SignupHeader />
      <EmailSignupForm />
    </div>
  </section>
);

export default SignupSection;